<template>
  <div class="overlay" @click.self="close">
    <div class="drawer">
      <div class="header">
        <div class="title">Создать Telegram-топик</div>
        <button class="close-btn" @click="close">✕</button>
      </div>

      <div class="body">
        <label>
          Заголовок
          <input
            v-model="form.title"
            type="text"
            placeholder="Введите тему поста"
          />
        </label>

        <label>
          Название картинки
          <input
            v-model="form.imageName"
            type="text"
            placeholder="Введите название картинки"
          />
        </label>

        <label>
          Дата публикации
          <input
            v-model="form.publishAt"
            type="date"
          />
        </label>
      </div>

      <div class="footer">
        <button class="secondary" @click="close">
          Отмена
        </button>
        <button
          class="primary"
          :disabled="isLoading || !isValid"
          @click="submit"
        >
          {{ isLoading ? 'Создание...' : 'Создать' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, ref } from 'vue'
import AdminService from '../api/AdminService'

const emit = defineEmits(['close', 'created'])

const isLoading = ref(false)

const form = reactive({
  title: '',
  imageName: '',
  publishAt: ''
})

const isValid = computed(() => {
  return form.title.trim().length > 3 && form.publishAt
})

function close() {
  emit('close')
}

async function submit() {
  if (!isValid.value) return

  try {
    isLoading.value = true

    await AdminService.createAdminTelegramTopic({
      title: form.title.trim(),
      imageName: form.imageName.trim(),
      publishAt: form.publishAt
    })

    emit('created')
    close()
  } catch (e) {
    console.error('❌ Ошибка создания топика', e)
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.drawer {
  width: 420px;
  background: white;
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

label {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 6px;
}

input {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

button {
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
}

button.primary {
  background: #2f6fed;
  color: white;
  border: none;
}

button.primary:disabled {
  opacity: 0.6;
  cursor: default;
}

button.secondary {
  background: #eee;
  border: none;
}
</style>